const LOGO_DEV_TOKEN = process.env.REACT_APP_LOGODEV_API_KEY || 'pk_DrKYNBAWTLqep746_gKuYA';

/**
 * Convert a Clearbit logo URL to a Logo.dev URL.
 */
export function getLogoUrl(companyLogo, size = 128) {
  if (!companyLogo) return '';
  if (companyLogo.includes('logo.clearbit.com/')) {
    const domain = companyLogo.split('logo.clearbit.com/')[1]?.split('?')[0];
    if (domain) {
      return `https://img.logo.dev/${domain}?token=${LOGO_DEV_TOKEN}&size=${size}&format=png`;
    }
  }
  return companyLogo;
}

/**
 * Format a date string (YYYY-MM-DD or ISO datetime) as a relative time label.
 * ISO datetime: "2026-03-08T14:30:00Z" → "2h ago" | "45m ago" | "3d ago"
 * Date-only: "2026-03-08" → "Today" | "1d ago" | "Feb 25"
 */
export function formatRelativeDate(dateStr) {
  if (!dateStr) return '';
  try {
    const hasTime = dateStr.includes('T');
    const date = hasTime
      ? new Date(dateStr)
      : new Date(dateStr + 'T00:00:00Z');
    const diffMs = Date.now() - date.getTime();
    if (diffMs < 0) return '';

    if (hasTime) {
      // Precise relative time for ISO datetimes
      const diffMinutes = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);
      if (diffMinutes < 1) return 'Just now';
      if (diffMinutes < 60) return `${diffMinutes}m ago`;
      if (diffHours < 24) return `${diffHours}h ago`;
      if (diffDays === 1) return '1d ago';
      if (diffDays < 7) return `${diffDays}d ago`;
      if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
    } else {
      // Day-level precision for date-only strings
      const diffDays = Math.floor(diffMs / 86400000);
      if (diffDays === 0) return 'Today';
      if (diffDays === 1) return '1d ago';
      if (diffDays < 7) return `${diffDays}d ago`;
      if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
    }
  } catch {
    return '';
  }
}

